import ReferenceData from "../constants/ReferenceData";
import { executeGet } from "../utils/apiUtils";

export const getDefaultAcctsCustRetrievalList = () => {
    const getDefaultAcctsCustRetrievalResult = (response) => {
        return response.data;
    };

    const url = __styleEnv__ + ReferenceData.DEFAULT_ACCTS_CUST_RETRIEVAL_URL;

    return executeGet(url, "getDefaultAcctsCustRetrievalFault")
        .then(getDefaultAcctsCustRetrievalResult)
        .catch((error) => {
            console.log("Error: ", error);
        });
};
